import React from 'react';
import { CheckCircle2Icon } from './icons';
import { CtaButton } from './CtaButton';
import { Pill } from './Pill';
import { heroImage } from '../data/copy';
const badges = ['Immediate Access', 'Secure Payment', '7-Day Guarantee'];
export function Hero() {
  return <header className="w-full bg-blush" data-id="element-91" data-mp="9igw3ammlskp">
      <div className="mx-auto max-w-4xl px-6 pb-10 pt-6 text-center sm:pb-12 sm:pt-8" data-id="element-92" data-mp="4mi5rhhqm0hn">
        <Pill data-id="element-93" data-mp="12a0l5b5wm0um">Ballet Teacher Elite System</Pill>

        <h1 className="mx-auto mt-5 max-w-2xl font-display text-[2rem] leading-[1.08] text-charcoal sm:text-[2.75rem] lg:text-5xl" data-id="element-94" data-mp="128pgza8jqr2z">
          Stop Planning From Scratch.
          <span className="mt-1 block text-wine" data-id="element-95" data-mp="sa9n4zi4x3ps">
            Solve an Entire Year of Ballet Classes in Minutes.
          </span>
        </h1>

        <div className="mx-auto mt-5 max-w-md rounded-3xl border border-rose-deep/25 bg-cream/70 p-3 shadow-soft sm:max-w-lg sm:p-4" data-id="element-96" data-mp="nekmesudpgrw">
          <img src={heroImage} alt="The complete Ballet Teacher Elite System: six master volumes, seven bonus books and printable planners." className="mx-auto w-full rounded-2xl" width={1240} height={1240} decoding="async" {...{
          fetchpriority: 'high'
        }} data-id="element-97" data-mp="381xjaspbqs7j" />
        </div>

        <p className="mx-auto mt-5 max-w-xl font-sans text-sm leading-relaxed text-ash sm:text-base" data-id="element-98" data-mp="39cpawocr98zq">
          <span className="font-medium text-wine" data-id="element-99" data-mp="3eb8xmqz6aot5">
            6 Master Volumes + 7 Strategic Bonuses
          </span>{' '}
          — the complete ready-to-teach library for ages 3 to 16.
        </p>

        <div className="mt-5" data-id="element-100" data-mp="2qjv8etwbj9ce">
          <CtaButton size="large" data-id="element-101" data-mp="2qkmt39odnmnw">Get the Elite System</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-6 gap-y-2" data-id="element-102" data-mp="2viokchvyisag">
          {badges.map(badge => <li key={badge} className="flex items-center gap-2 font-sans text-xs font-medium tracking-wide text-ash" data-id="element-103" data-mp="2hk8685vrlzia">
              <CheckCircle2Icon className="h-4 w-4 text-goldink" strokeWidth={1.6} aria-hidden="true" data-id="element-104" data-mp="s21iocxnug0i" />
              {badge}
            </li>)}
        </ul>
      </div>
    </header>;
}